import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import rocketImage from "../../assets/img/roket.png";
import lockImage from "../../assets/img/lock.png";
import dollarImage from "../../assets/img/dollar.png";
import hoursImage from "../../assets/img/hours.png";

const services = [
  {
    id: 1,
    image: rocketImage,
    title: "Sürətli xidmət",
    description: "Aldığınız məhsullar ən sürətli şəkildə sizə çatdırılır.",
    accent: "fuchsia",
  },
  {
    id: 2,
    image: lockImage,
    title: "Təhlükəsizlik",
    description: "Ödənişlərinizi ən təhlükəsiz üsullarla həyata keçirə bilərsiniz.",
    accent: "cyan",
  },
  {
    id: 3,
    image: dollarImage,
    title: "Sərfəli qiymət",
    description: "Endirimlər və uyğun qiymətlərlə alış-verişdən zövq alın.",
    accent: "fuchsia",
  },
  {
    id: 4,
    image: hoursImage,
    title: "İş saatları",
    description: "11:00-dan 04:00-a qədər xidmətinizdəyik.",
    accent: "cyan",
  },
];

const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false, // Scroll etdikdə animasiya təkrar işləyir
      mirror: true, // Yuxarı scroll edərkən də animasiyanı yeniləyir
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <section className="relative w-full overflow-hidden border-y border-black/[0.04] bg-white py-12 text-slate-900 transition-colors duration-500 sm:py-14 md:py-16 dark:border-white/[0.05] dark:bg-[#050507] dark:text-white">
      {/* Background glow */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div
          data-aos="fade-right"
          data-aos-delay="100"
          className="absolute -left-32 top-0 h-72 w-72 rounded-full bg-fuchsia-500/[0.035] blur-3xl dark:bg-fuchsia-500/[0.06]"
        />

        <div
          data-aos="fade-left"
          data-aos-delay="200"
          className="absolute -right-32 bottom-0 h-72 w-72 rounded-full bg-cyan-500/[0.035] blur-3xl dark:bg-cyan-500/[0.05]"
        />

        {/* Subtle grid */}
        <div
          className="
            absolute
            inset-0
            opacity-[0.018]
            [background-image:linear-gradient(rgba(0,0,0,.4)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,.4)_1px,transparent_1px)]
            [background-size:30px_30px]
            dark:opacity-[0.025]
            dark:[background-image:linear-gradient(rgba(255,255,255,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.35)_1px,transparent_1px)]
          "
        />
      </div>

      {/* Top accent line */}
      <div className="pointer-events-none absolute left-0 right-0 top-0 h-px bg-gradient-to-r from-transparent via-fuchsia-500/50 to-transparent" />

      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section heading */}
        <div
          data-aos="fade-down"
          data-aos-duration="600"
          className="mb-10 text-center sm:mb-12"
        >
          <div className="mb-3 flex items-center justify-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-fuchsia-500 shadow-[0_0_10px_rgba(217,70,239,.75)]" />

            <span className="text-[9px] font-black tracking-[0.32em] text-fuchsia-500">
              FFQADIR AZ
            </span>

            <span className="h-1.5 w-1.5 rounded-full bg-cyan-500 shadow-[0_0_10px_rgba(6,182,212,.65)]" />
          </div>

          <h2 className="text-xl font-black tracking-tight text-slate-900 sm:text-2xl dark:text-white">
            NİYƏ BİZ?
          </h2>

          <p className="mx-auto mt-2 max-w-xl text-[11px] leading-6 tracking-wide text-slate-400 dark:text-white/30">
            Sürətli xidmət, təhlükəsiz ödəniş və rahat alış-veriş təcrübəsi
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 lg:gap-5">
          {services.map((service, index) => {
            const isFuchsia = service.accent === "fuchsia";

            return (
              <div
                key={service.id}
                data-aos="fade-up"
                data-aos-delay={index * 100} // Kartlar ardıcıl olaraq gəlir
                data-aos-duration="600"
                className="
                  group
                  relative
                  overflow-hidden
                  rounded-2xl
                  border
                  border-black/[0.06]
                  bg-white/80
                  px-3
                  py-5
                  text-center
                  shadow-[0_8px_30px_rgba(0,0,0,0.04)]
                  backdrop-blur-xl
                  transition-all
                  duration-500
                  hover:-translate-y-1.5
                  hover:shadow-[0_18px_45px_rgba(0,0,0,0.08)]
                  sm:px-5
                  sm:py-7
                  dark:border-white/[0.07]
                  dark:bg-white/[0.025]
                  dark:shadow-[0_10px_35px_rgba(0,0,0,0.20)]
                  dark:hover:shadow-[0_20px_50px_rgba(0,0,0,0.35)]
                "
              >
                {/* Card glow */}
                <div
                  className={`
                    pointer-events-none
                    absolute
                    -right-12
                    -top-12
                    h-28
                    w-28
                    rounded-full
                    blur-3xl
                    transition-opacity
                    duration-500
                    group-hover:opacity-100
                    ${
                      isFuchsia
                        ? "bg-fuchsia-500/[0.06] dark:bg-fuchsia-500/[0.10]"
                        : "bg-cyan-500/[0.06] dark:bg-cyan-500/[0.10]"
                    }
                  `}
                />

                {/* Bottom accent */}
                <div
                  className={`
                    absolute
                    bottom-0
                    left-1/2
                    h-px
                    w-0
                    -translate-x-1/2
                    transition-all
                    duration-500
                    group-hover:w-20
                    ${
                      isFuchsia
                        ? "bg-fuchsia-500 shadow-[0_0_12px_rgba(217,70,239,.65)]"
                        : "bg-cyan-500 shadow-[0_0_12px_rgba(6,182,212,.65)]"
                    }
                  `}
                />

                {/* Icon */}
                <div
                  className={`
                    relative
                    mx-auto
                    mb-4
                    flex
                    h-16
                    w-16
                    items-center
                    justify-center
                    rounded-2xl
                    border
                    bg-white
                    p-3
                    shadow-sm
                    transition-all
                    duration-500
                    group-hover:-translate-y-1
                    sm:mb-5
                    sm:h-20
                    sm:w-20
                    sm:p-4
                    dark:bg-[#0b0b10]
                    ${
                      isFuchsia
                        ? "border-fuchsia-500/10 group-hover:border-fuchsia-500/30 group-hover:shadow-[0_10px_30px_rgba(217,70,239,.15)]"
                        : "border-cyan-500/10 group-hover:border-cyan-500/30 group-hover:shadow-[0_10px_30px_rgba(6,182,212,.15)]"
                    }
                  `}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105"
                  />

                  <span
                    className={`
                      pointer-events-none
                      absolute
                      inset-0
                      rounded-2xl
                      opacity-0
                      blur-xl
                      transition-opacity
                      duration-500
                      group-hover:opacity-100
                      ${isFuchsia ? "bg-fuchsia-500/5" : "bg-cyan-500/5"}
                    `}
                  />
                </div>

                {/* Title */}
                <h3 className="relative text-[12px] font-black tracking-tight text-slate-800 sm:text-base dark:text-white">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="relative mx-auto mt-2 max-w-xs text-[9px] leading-5 text-slate-400 sm:text-[11px] sm:leading-6 dark:text-white/35">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;